fx.ns("desktop.common.toolbar", class ToolBarSelectFont extends desktop.common.toolbar.ToolBarSelect{
    
    constructor(command, component, container)
    {
        super(command, component, container); 
    }

    onReady()
    {
        super.onReady();
        this.verticalList.top(this.realHeight);
    }

    render()
    {
        let current = this.command.items.find({id : this.component[this.command.field] }); 
        
        return "<div class='label'><img class='image' src='" + current.thumb + "'></div>";
        
    }

    onSelected(e)
    {
        this.find(".image").src = e.detail.thumb;

        this.action( e.detail );
        
    }

    selectionChanged()
    {
        this.verticalList.selected = this.component[this.command.field];

        let current = this.command.items.find({id : this.component[this.command.field] }); 
        
        this.find(".image").src = current.thumb;
    }

});